/**
 * Storefront-search strip — shows on /coupons?q=... above the offer results.
 * Jumps the shopper to matched brands first (§47-48 storefront-first search).
 */
import { useEffect, useState } from "react";
import { Store } from "lucide-react";
import api from "@/lib/api";
import { BrandCard } from "@/components/BrandsFeed";

export default function StorefrontSearchStrip({ q }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!q) { setRows([]); return; }
    api.get(`/v1/storefronts/search?q=${encodeURIComponent(q)}&limit=8`)
      .then((r) => setRows(r.data.items || []))
      .catch(() => setRows([]));
  }, [q]);
  if (!q || rows.length === 0) return null;
  return (
    <section className="mb-8" data-testid="search-storefront-strip">
      <div className="flex items-center gap-2 mb-3">
        <Store className="w-4 h-4 text-slate-500" />
        <h2 className="font-display text-lg text-slate-900">
          Brands matching "<span className="text-cyan-700">{q}</span>"
        </h2>
        <span className="text-xs text-slate-500 ml-1">({rows.length})</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {rows.map((sf) => <BrandCard key={sf.id} sf={sf} compact />)}
      </div>
    </section>
  );
}
